var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00005 3.80002L2.10005 6.70002C1.91672 6.88336 1.68338 6.97502 1.40005 6.97502C1.11672 6.97502 0.883382 6.88336 0.700049 6.70002C0.516715 6.51669 0.425049 6.28336 0.425049 6.00002C0.425049 5.71669 0.516715 5.48336 0.700049 5.30002L5.30005 0.700024C5.50005 0.500024 5.73338 0.400024 6.00005 0.400024C6.26672 0.400024 6.50005 0.500024 6.70005 0.700024L11.3 5.30002C11.4834 5.48336 11.575 5.71669 11.575 6.00002C11.575 6.28336 11.4834 6.51669 11.3 6.70002C11.1167 6.88336 10.8834 6.97502 10.6 6.97502C10.3167 6.97502 10.0834 6.88336 9.90005 6.70002L7.00005 3.80002V12C7.00005 12.2834 6.90422 12.5209 6.71255 12.7125C6.52088 12.9042 6.28338 13 6.00005 13C5.71672 13 5.47922 12.9042 5.28755 12.7125C5.09588 12.5209 5.00005 12.2834 5.00005 12V3.80002Z",
    fill: "#4282A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBlueIcon);
export default __webpack_public_path__ + "static/media/arrow-up-blue-icon.2b7721028a69d1d8251b93df102af005.svg";
export { ForwardRef as ReactComponent };